module.exports = __webpack_public_path__ + "static/media/chevron_right.96d4e58f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/chevron_right.svg
// module id = 2202
// module chunks = 0